module.exports = __webpack_public_path__ + "img/freeModeMenu.63296ecc.svg";